// Centralised session/token handling for the admin dashboard.

export const TOKEN_KEY = "ft9jaAdminToken";
export const ADMIN_KEY = "ft9jaPromo"; // kept for backwards compatibility
export const EMAIL_KEY = "ft9jaAdminEmail";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const isAdmin = () => localStorage.getItem(ADMIN_KEY) === "true";

export const isAuthed = () => !!getToken() && isAdmin();

export const setSession = ({ token, email, isAdmin } = {}) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (email) localStorage.setItem(EMAIL_KEY, email);
  localStorage.setItem(ADMIN_KEY, String(!!isAdmin));
};

export const clearSession = () => {
  [TOKEN_KEY, ADMIN_KEY, EMAIL_KEY].forEach((k) => localStorage.removeItem(k));
};

// Attach the bearer token to every request and bounce to the login screen on
// an expired/invalid session.
export const installAuthInterceptors = (client) => {
  client.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error && error.response && error.response.status === 401) {
        clearSession();
        const path = window.location.pathname || "";
        if (path !== "/") {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );
};
